<template>
  <div class="styled-html">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.styled-html {
  :deep() {
    ol,
    p,
    ul {
      &:not(:last-child) {
        margin: 0 0 1em;
      }
    }

    ol,
    ul {
      padding-left: 1.2em;
      list-style: initial;
    }

    li {
      list-style: initial;
    }
  }
}
</style>
